import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, Clock3Icon, HeartHandshakeIcon, SaladIcon, SmartphoneIcon } from 'lucide-react';
const recipes = [['Desayunos', 'https://images.unsplash.com/photo-1494597564530-871f2b93ac55?auto=format&fit=crop&w=1000&q=85', 'col-span-2 row-span-2'], ['Bowls', 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=700&q=85', ''], ['Salmón', 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&w=700&q=85', ''], ['Smoothies', 'https://images.unsplash.com/photo-1553530666-ba11a7da3888?auto=format&fit=crop&w=700&q=85', ''], ['Pancakes', 'https://images.unsplash.com/photo-1528207776546-365bb710ee93?auto=format&fit=crop&w=1000&q=85', 'col-span-2'], ['Ensaladas', 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=700&q=85', ''], ['Snacks', 'https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=700&q=85', ''], ['Comida real', 'https://images.unsplash.com/photo-1543353071-873f17a7a088?auto=format&fit=crop&w=1000&q=85', 'col-span-2']];
export function RecipesAccess() {
  return <>
      <section id="recetas" className="bg-[#e8ecdf] py-24 sm:py-32" data-id="element-298">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-299">
          <div className="max-w-3xl" data-id="element-300">
            <p className="text-xs font-bold tracking-[0.2em] text-[#65785b]" data-id="element-301">
              SABOR DE VERDAD
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-302">
              Algunas de las recetas que encontrarás
            </h2>
            <p className="mt-6 text-lg leading-8 text-[#5e6e59]" data-id="element-303">
              Ideas que abren el apetito y te hacen querer volver a la cocina.
            </p>
          </div>
          <div className="mt-14 grid auto-rows-[155px] grid-cols-2 gap-3 md:grid-cols-4 md:auto-rows-[180px]" data-id="element-304">
            {recipes.map(([title, src, placement], index) => <motion.figure key={title} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className={`group relative overflow-hidden ${placement}`} data-id="element-305">
                <img src={src} alt={`Receta de ${title.toLowerCase()}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-306" />
                <figcaption className="absolute bottom-0 left-0 right-0 bg-[#253323]/70 px-4 py-3 text-sm font-medium text-white" data-id="element-307">
                  {title}
                </figcaption>
              </motion.figure>)}
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-308">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-309">
          <div className="text-center" data-id="element-310">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-311">
              HECHO PARA LA VIDA REAL
            </p>
            <h2 className="font-display mx-auto mt-5 max-w-3xl text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-312">
              Comer saludable nunca había sido tan fácil
            </h2>
          </div>
          <div className="mt-14 grid gap-10 md:grid-cols-3" data-id="element-313">
            {[[SaladIcon, 'Más de 550 recetas', 'Recetas variadas que hacen que comer bien se sienta abundante, nunca limitado.'], [CheckCircle2Icon, 'Preparación paso a paso', 'Instrucciones claras e ingredientes fáciles de encontrar para cocinar con confianza.'], [Clock3Icon, 'Pensado para tu ritmo', 'Recetas listas en menos de 30 minutos y opciones para toda la familia.']].map(([Icon, title, copy]) => {
            const BenefitIcon = Icon as typeof SaladIcon;
            return <div key={title as string} className="border-t border-[#cfd5c8] pt-6" data-id="element-314">
                  <BenefitIcon className="text-[#607956]" size={30} strokeWidth={1.4} data-id="element-315" />
                  <h3 className="font-display mt-7 text-2xl text-[#344833]" data-id="element-316">
                    {title as string}
                  </h3>
                  <p className="mt-3 leading-7 text-[#65705f]" data-id="element-317">
                    {copy as string}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="overflow-hidden bg-[#e8e5d9] py-24 sm:py-32" data-id="element-318">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[.85fr_1.15fr] lg:items-center" data-id="element-319">
          <div data-id="element-320">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-321">
              CONTIGO, DONDE ESTÉS
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-322">
              Diseñado para acompañarte todos los días
            </h2>
            <p className="mt-6 max-w-md text-lg leading-8 text-[#5e6b59]" data-id="element-323">
              Abre el sistema desde tu teléfono, tablet o computadora. Tu
              próxima comida está siempre a unos minutos de distancia.
            </p>
            <div className="mt-8 flex items-center gap-3 text-sm font-medium text-[#445940]" data-id="element-324">
              <SmartphoneIcon size={21} data-id="element-325" /> Compatible con todos tus
              dispositivos.
            </div>
          </div>
          <div className="relative mx-auto flex h-[390px] w-full max-w-xl items-end justify-center gap-4 sm:h-[470px]" data-id="element-326">
            <div className="absolute inset-x-0 bottom-0 h-72 bg-[#d4dacb]" data-id="element-327" />
            <div className="relative z-10 h-[260px] w-[130px] overflow-hidden rounded-[22px] border-[7px] border-[#2d3b2c] bg-[#fcfbf7] shadow-2xl sm:h-[315px] sm:w-[155px]" data-id="element-328">
              <img src="https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=500&q=80" alt="Receta Código Fitness en teléfono" className="h-2/5 w-full object-cover" data-id="element-329" />
              <p className="p-3 text-[10px] font-bold text-[#405a3b]" data-id="element-330">
                ENSALADA DE TEMPORADA
              </p>
              <div className="mx-3 h-1.5 bg-[#dbe2d3]" data-id="element-331" />
              <div className="m-3 h-1.5 w-2/3 bg-[#e6e8e1]" data-id="element-332" />
            </div>
            <div className="relative z-10 hidden h-[300px] w-[220px] overflow-hidden rounded-t-lg border-8 border-[#4b5549] bg-[#fffefa] shadow-2xl sm:block" data-id="element-333">
              <img src="https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?auto=format&fit=crop&w=700&q=80" alt="Planificador digital en tablet" className="h-1/2 w-full object-cover" data-id="element-334" />
              <p className="p-5 text-xs font-bold tracking-wider text-[#405a3b]" data-id="element-335">
                TU SEMANA, A TU RITMO
              </p>
            </div>
            <div className="relative z-10 hidden h-[250px] w-[320px] overflow-hidden rounded-t-lg border-[9px] border-[#3e493d] bg-[#fffefa] shadow-2xl lg:block" data-id="element-336">
              <img src="https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=700&q=80" alt="Guía Código Fitness en computadora" className="h-3/5 w-full object-cover" data-id="element-337" />
              <p className="p-4 text-xs font-bold text-[#405a3b]" data-id="element-338">
                RECETAS PARA TODOS LOS DÍAS
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}